// extracted by mini-css-extract-plugin
export default {"cardsWrapper":"vJ2tVOf1","work":"hKOD63n7","imgBox":"WWVOTOiI","text":"zfAEOC4N"};
    if(module.hot) {
      // 1712151479853
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  